module.exports = __webpack_public_path__ + "static/img/fazhan_02.ca6e7a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/aboutPage/fazhan_02.jpg
// module id = /WVn
// module chunks = 14